
import React, { useCallback } from 'react'
import { Grid } from 'semantic-ui-react'
import InputField from '@commonComponents/formComponents/CustomInputField'
import DeleteIcon from '@commonComponents/deleteIcon'

const ActorForm = (props) => {
    const {
        actorType,
        tableName,
        dataSource: { id, name, eoriNo },
        onChange,
        onBlur,
        onSelect,
        deleteData
    } = props

    const onChangeHandler = useCallback(({ target: { value, name } }) => onChange(id, tableName, { [name]: value }), [tableName, id, onChange])
    const onBlurHandler = useCallback(({ target: { value, name } }) => onBlur(tableName, { [name]: value, id }), [tableName, id, onBlur])
    
    return (
        <div className="formContainer">
            <Grid.Row>
                <Grid.Column>
                    <InputField
                        id={`name${id}`}
                        type='text'
                        name="name"
                        value={name}
                        label="NAME"
                        clearInput={false}
                        className="field-bg"
                        onChange={onChangeHandler}
                        onBlur={onBlurHandler}
                    />
                </Grid.Column>
                <Grid.Column>
                    <InputField
                        id={`eoriNo${id}`}
                        name="eoriNo"
                        type='text'
                        value={eoriNo}
                        label="EORI"
                        clearInput={false}
                        className="field-bg"
                        onChange={onChangeHandler}
                        onBlur={onBlurHandler}
                    />
                </Grid.Column>
            </Grid.Row>
            <div className="actionbtns">
                <DeleteIcon onClick={() => deleteData(id, tableName)} />
            </div>
        </div>
    )
}

export default ActorForm